import { get } from "../../utils/BaseService";

export async function getMailHistoryByInvoiceId(dispatch: any,id:number) {
  return await get(dispatch, `/mailHistory/getByInvoiceId/${id}`, null);
}